import EcoVideo from 'eco-design/base/eco-video';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const BreakLimits: React.FC = () => {
    const { t } = useLang('zero_bills');
    return (
        <div className={styles.BreakLimits}>
            <EcoVideo
                pc="https://websiteoss.ecoflow.com/upload/video/1748499366687/ECOFLOW_CLEAN-4k_1_H.264.mp4"
                h5="https://websiteoss.ecoflow.com/upload/video/1748499652904/ECOFLOW_CLEAN-4k_1_H.264%20(2).mp4"
                autoPlay
                loop
            />
            <div className="title-wrapper">
                <div className="title">{t('label')}</div>
            </div>
        </div>
    );
};

export default BreakLimits;
